import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ErrorHandleService } from './error-handle.service';
import { UrlEndpoint } from './url-endpoint.service';
import { AlertService, MessageSeverity } from './alert.service';
import { UrlInfo } from '../models/url.info.model';

@Injectable({
  providedIn: 'root'
})

export class UrlService {

  constructor(private errorHandleService: ErrorHandleService,
    private urlEndpoint: UrlEndpoint, private alertService: AlertService, ) { }

  getSaikiTubeUrl(): Observable<UrlInfo> {
    const result = new UrlInfo();

    this.urlEndpoint.getSaikiTubeUrlEndpoint<UrlInfo>().subscribe(response => {

      result.update(response);
    }, error => this.errorHandleService.showMessageAndRedirect("データ取得失敗", "ライブ配信URL取得中にエラーが発生しました。", error));

    return of(result);
  }

  updateSaikiTubeUrl(url: string): Observable<UrlInfo> {
    const result = new UrlInfo();

    this.alertService.startUpdatingMessage();
    this.urlEndpoint.updateSaikiTubeUrlEndpoint<UrlInfo>(url).subscribe(response => {
      this.alertService.stopUpdatingMessage();
      result.update(response);
      this.alertService.showStickyMessage("データ更新成功", "ライブ配信URLを更新しました。", MessageSeverity.success);
    }, error => {
      this.alertService.stopUpdatingMessage();
      this.errorHandleService.showMessageAndRedirect("データ更新失敗", "ライブ配信URL更新中にエラーが発生しました。", error);
    });

    return of(result);
  }
}
